<template>
    <b-form-group
      label="Tipo de Movimentação"
      label-for="tipo-de-movimentacao"
      label-class="font_size_label tipo_de_movimentacao"
    >
      <validation-provider #default="{ errors }" name="Tipo de Movimentação">
        <v-select
          id="tipo-de-movimentacao"
          :options="options"
          v-model="selected"
          placeholder="Selecione o tipo de movimentação"
          label="descricao"
          :clearable="true"
          multiselect
          multiple
        >
          <span slot="no-options">Nenhuma opção selecionável.</span>
        </v-select>
        <small v-if="errors[0]" class="text-danger">
          {{ errors[0] }}
        </small>
      </validation-provider>
    </b-form-group>
  </template>
  
  <script>
  import {
    BForm,
    BCol,
    BRow,
    BFormGroup,
    BFormInput,
    BButton,
    BTable,
    BSpinner,
    BFormDatepicker,
    BFormTextarea,
    BOverlay,
  } from "bootstrap-vue";
  import { ValidationProvider, ValidationObserver } from "vee-validate";
  import vSelect from "vue-select";
  
  export default {
    components: {
      BForm,
      BCol,
      BRow,
      BFormGroup,
      BFormInput,
      BButton,
      BTable,
      BSpinner,
      BFormDatepicker,
      BFormTextarea,
      BOverlay,
      ValidationProvider,
      ValidationObserver,
      vSelect,
    },
    props: {
      value: {
        required: true,
      },
      optionsConsulted: {
        required: false,
        type: Array,
        default: () => [],
      },
    },
    data() {
      return {
        options: [],
        selected: this.value,
        parametros: {
          params: {
            paginacao: false,
          },
        },
      };
    },
    beforeMount() {
      this.setOptions();
    },
    methods: {
      async setOptions() {
        if (this.optionsConsulted.length > 0) {
          this.options = this.optionsConsulted;
          return;
        }
  
        await this.$http
          .get(this.$api.tipoMovimentacao(), this.parametros)
          .then(({ data }) => {
            this.options = data;
          });
      },
    },
    watch: {
      selected: function (valor) {
        this.$emit("selected", valor);
      },
      options: function (valor) {
        this.$emit("options", valor);
      },
    },
  };
  </script>
